"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function RemoteMovement(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M20 2c1.1 0 2 .9 2 2v16c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2zm-8 2c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8zm8 13.99c-.57.76-1.25 1.44-2.01 2.01H20zm-16 0V20h2.01c-.76-.57-1.44-1.25-2.01-2.01zm13.388-9.88a5.499 5.499 0 0 1 0 7.78.99.99 0 0 1-.71.29c-.261 0-.52-.1-.7-.29a.976.976 0 0 1 0-1.41 3.526 3.526 0 0 0 0-4.96.976.976 0 0 1 0-1.41.994.994 0 0 1 1.41 0zm-9.369 0a.993.993 0 0 1 0 1.41A3.502 3.502 0 0 0 7 12c0 .94.362 1.81 1.02 2.48a.993.993 0 0 1-.699 1.7.982.982 0 0 1-.71-.29A5.461 5.461 0 0 1 5 12c0-1.47.57-2.85 1.61-3.89a.993.993 0 0 1 1.41 0zm2.42 1.41c.392.39.392 1.03 0 1.42a1.457 1.457 0 0 0-.438 1.06c0 .4.15.78.439 1.06.39.39.39 1.03 0 1.42-.19.18-.44.29-.71.29-.27 0-.52-.11-.71-.29A3.482 3.482 0 0 1 8 12c0-.94.36-1.82 1.02-2.48.39-.39 1.03-.39 1.42 0zm4.531 0c.67.66 1.03 1.54 1.03 2.48s-.36 1.82-1.03 2.48c-.18.18-.44.29-.7.29-.27 0-.52-.11-.709-.29a1.006 1.006 0 0 1 0-1.42 1.502 1.502 0 0 0 0-2.12 1.006 1.006 0 0 1 0-1.42.995.995 0 0 1 1.409 0zm-2.264 1.772a1 1 0 1 1-1.415 1.418 1 1 0 0 1 1.415-1.418zM6.01 4H4v2.01C4.57 5.25 5.25 4.57 6.01 4zM20 4h-2.01c.76.57 1.44 1.25 2.01 2.01V4z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = RemoteMovement;
